<script>
export default {
	name: 'stanjefilter-dropdown',
	methods: {
		click_Item (item) {
			this.allSelected = false;
			this.selectItem(item.value);
			this.$emit('change', this.selectedItems);
		},
		click_Vse (evt) {
			this.selectItem();
			this.allSelected = true;
			this.$emit('change', []);
		},
		selectItem (value) {
			this.selectedItems = [];
			for (let item of this.items) {
				if (this.multiselect) {
					if (value) {
						if (value === item.value) {
							item.active = !item.active;
						}
					} else {
						item.active = false;
					}
				} else {
					if (value) {
						if (value === item.value) {
							item.active = true;
						} else {
							item.active = false;
						}
					} else {
						item.active = false;
					}
				}
				if (item.active) {
					this.selectedItems.push(item);
				}
			}
			if (this.selectedItems.length === 0) {
				this.allSelected = true;
			}
		},
		clear () {
			this.selectItem();
		}
	},
	computed: {
		selectedTitle () {
			if (this.selectedItems.length === 0) {
				return this.defaultItemLabel;
			} else if (this.selectedItems.length === 1) {
				return this.selectedItems[0].label;
			} else {
				return this.selectedItems[0].label + ' ...';
			}
		}
	},
	data: () => {
		return {
			defaultItemLabel: 'Vse',
			selectedItems: [],
			multiselect: true,
			allSelected: true,
			items: [
				{
					label: 'ARA',
					value: 'ARA',
					active: false
				},
				{
					label: 'ARA/>90',
					value: 'ARA/>90',
					active: false
				},
				{
					label: 'EXPE',
					value: 'EXPE',
					active: false
				},
				{
					label: 'M+1',
					value: 'M+1',
					active: false
				},
				{
					label: 'M+2',
					value: 'M+2',
					active: false
				},
				{
					label: 'MADC',
					value: 'MADC',
					active: false
				},
				{
					label: 'OC',
					value: 'OC',
					active: false
				},
				{
					label: 'pred AF',
					value: 'pred AF',
					active: false
				},
				{
					label: 'TOVAR',
					value: 'TOVAR',
					active: false
				},
				{
					label: 'TRPP',
					value: 'TRPP',
					active: false
				},
				{
					label: 'ZPRT',
					value: 'ZPRT',
					active: false
				},
				{
					label: 'PROIZVODNJA',
					value: 'PROIZVODNJA',
					active: false
				},
				{
					label: 'AVTOTEHNIKA CELJE',
					value: 'AVTOTEHNIKA CELJE',
					active: false
				},
				{
					label: 'ATK/PRESK/CE.',
					value: 'ATK/PRESK/CE.',
					active: false
				},
				{
					label: 'TRANSPORT IZ AMSTERD',
					value: 'TRANSPORT IZ AMSTERD',
					active: false
				}
			]
		}
	}
}
</script>
<template>
<b-dropdown :text="selectedTitle" ref="dropdown">
	<b-dropdown-header>Stanje</b-dropdown-header>
	<b-dropdown-item @click="click_Item(item)" v-for="item in items" :key="item.value" :active="item.active">
		{{ item.label }}
	</b-dropdown-item>
	<b-dropdown-divider></b-dropdown-divider>
	<b-dropdown-item @click="click_Vse" :active="allSelected">{{ defaultItemLabel }}</b-dropdown-item>
</b-dropdown>
</template>
<style>
</style>


// WEBPACK FOOTER //
// src/components/StanjeFilterDropdown.vue